import { makeStyles } from '../../../../../../styles';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1),
        gap: theme.spacing(1),
        '&.active': {
            cursor: 'default',
            '&:hover': {
                backgroundColor: theme.colors.primary.contrastWhite,
            },
        },
        '&.disabled': {
            cursor: 'default',
            '&:hover': {
                backgroundColor: theme.colors.primary.contrastWhite,
            },
        },
        '&.openingDisallowed': {
            cursor: 'not-allowed',
        },
    },
    viewName: {
        color: theme.colors.text[900],
        wordBreak: 'break-word',
        textAlign: 'left',
        fontWeight: 600,
        '&.active': {
            color: theme.colors.primary.main,
        },
    },
    branchIcon: {
        minWidth: 20,
        minHeight: 20,
    },
}));
export default useStyles;
//# sourceMappingURL=PredefinedView.styles.js.map